import { maxWidth, minWidth } from '@/assets/styles/mixins.css.js'
import styled, { css } from 'styled-components'
import vars from '@/assets/styles/vars'
import GridArticle from './StyledGridArticle'

const PartitionGrid = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 342px);
  grid-auto-flow: column;
  gap: 20px;
  margin-bottom: 40px;

  ${maxWidth(vars.breakpoints.xsDesktop)`
    grid-template-columns: 1fr 1fr;
    grid-template-rows: unset;
    grid-auto-flow: row;
`}

  ${maxWidth(800)`
      grid-template-columns: 1fr;
      grid-template-rows: unset;
      grid-auto-flow: row;
      margin-bottom: 30px;
  `}
`

PartitionGrid.Item = styled.li`
  width:100%;
  height: 100%;
  overflow:hidden;

  &:first-child {
    height:409px;
  }
  &:nth-child(2) {
    height: 275px;
    margin-top: 67px
  }

  &:nth-child(3) {
    height: 274px;
  }

  &:nth-child(4) {
    height:410px;
    margin-top: -67px;
  }
  &:nth-child(5) {
    height: 704px;
    margin-bottom: -342px;
  }

  ${maxWidth(vars.breakpoints.xsDesktop)`
    &:nth-child(n) {
     height: 342px;
     margin: 0;
     }
 `}
  ${maxWidth(vars.breakpoints.tablet)`
     &:nth-child(n) {
      height: 342px;
      margin: 0;
      }
  `}
  ${maxWidth(vars.breakpoints.mobile)`
    &:nth-child(n) {
     height: 200px;
     }
 `}
  
`

PartitionGrid.Link = styled.a`
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  min-height: 100%;
  padding: 34px 30px;
  line-height: 1.16;
  color: var(--color-light);
  background: var(--color-decor);
  outline: 1px solid var(--color-border);

  & > * {
    width: 100%;
    opacity: 0.8;

    &:first-child {
      margin-bottom: 40px;
      font-size: 24px;
      opacity: 1;
    }
  }
`

PartitionGrid.Slider = styled.div`
  position: relative;
  z-index: 1;
  box-shadow: 0 0 0 1px var(--color-border);

  &::after {
    content: '';
    display: block;
    width: 100%;
    padding-top: 80%;
  }

  & > .swiper-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &:hover {
      .swiper-button-prev,
      .swiper-button-next {
        opacity: 1;
        pointer-events: all;
      }

      .swiper-button-disabled {
        opacity: 0.35;
      }
    }
  }

  .swiper-slide {
    width: 100%;
  }

  .swiper-button-prev,
  .swiper-button-next {
    opacity: 0;
    pointer-events: none;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    box-shadow: none;

    &::after {
      content: none;
    }

    .swiper-container {
      position: static;
      height: auto;
      display: flex;
      overflow: visible;
    }

    .swiper-wrapper {
      height: auto;
    }

    .swiper-slide {
      width: calc((100% - 20px) / 2);
      height: 100%;
      margin-right: 20px;
    }

    .swiper-pagination {
      display: none;
    }

    .swiper-button-prev,
    .swiper-button-next {
      display: none;
    }

    ${GridArticle.Title}, ${GridArticle.Date}, ${GridArticle.Arrow} {
      opacity: 1 !important;
      transform: none !important;
      transition: none !important;
    }
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    .swiper-slide {
      width: 100%;
      margin-right: 10px;
    }
  `}
`

PartitionGrid.HiddenTitle = styled.h2`
  margin-bottom: 24px;
  margin-top: 64px;
  font-weight: 300;
  font-size: 28px;
  line-height: 1.18;
  letter-spacing: -0.01em;

  ${minWidth(vars.breakpoints.tablet + 1)`
    display: none;
  `}
`

PartitionGrid.HiddenLink = styled.div`
  --button-width: 260px;
  --button-padding-top: 16px;
  --button-padding-bottom: 16px;
  margin-top: 32px;

  ${minWidth(vars.breakpoints.tablet + 1)`
    display: none;
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    --button-width: 100%;
  `}
`

export default PartitionGrid
